import { toast } from "react-toastify";
import { GetAllMaterialApi } from "../../../Api/Store/Material";

export const GetAllMaterial = (data) => {
  return {
    type: "get_all_material",
    payload: data,
    loader: false,
  };
};

export function getallMaterial() {
  return async (dispatch) => {
    try {
      const result = await GetAllMaterialApi();

      if (result.data?.IsSuccess === true) {
        dispatch(GetAllMaterial(result.data.Data));
      } else {
        toast.error(result.data?.Message || "Failed to fetch Materials");
      }
    } catch (error) {
      toast.error("Something went wrong while fetching Materials!");
    }
  };
}
